import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Card, CardHeader, Stack } from '@mui/material'
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from '../../components/MaterialTypography'
import MaterialButton from '../../components/MaterialButton'
import { useNavigate } from 'react-router-dom';
import MaterialDataGrid from '../../components/MaterialDataGrid';
import request from 'graphql-request';
import BASEURL from '../Utils/Baseurl';
import { getTaskList } from './GraphQl';
import { useAuth } from '../../context/AuthContext/AuthContextProvider';
import TableComponent from '../../components/GridTable/TableComponent';

const TaskStatusMonitoringList = () => {

    const navigate = useNavigate();
    const { currentUser, authenticated } = useAuth();
    const UserId = currentUser?.id;
    const [isLoading, setIsLoading] = useState(false);    
    const [taskProgressData, setTaskProgressData] = useState([]);
    const [globalSearchData, setGlobalSearchData] = useState([]);
    
    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: "init",
    });

    useEffect(() => {
      setGlobalSearchData(taskProgressData);
    }, [taskProgressData]);

    useEffect(() => {
        fetchAllTaskList();
    },[]);

    const taskStatusListTable = {
        columns: [
          {
            label: "S.No",
            field: "sno",
            name: "S.NO",
            // flex: 1,
            width: 50,
            disableColumnMenu: true,
            editable: false,
          },
          {
            label: "Task Title",
            field: "taskTitle",
            name: "calltaskTitledate",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
          },
    
          {
            label: "Sales Person",
            field: "salesPerson",
            name: "salesPerson",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
          },
    
    
          {
            label: "Status",
            field: "status",
            name: "status",
            flex: 1,
            disableColumnMenu: true,
            editable: false,
          },
          {
            label: "Work Completed",
            field: "percentage",
            name: "percentage",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            label: "Hours Worked",
            field: "hours",
            name: "hours",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            label: "Remaining Time",
            field: "remainingTime",
            name: "remainingTime",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            label: "Created At",
            field: "createdAt",
            name: "createdAt",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
      
        ],
        rows: taskProgressData.map((val, index) => ({
            id: val.id,
            sno: index + 1,
            taskTitle: val?.task?.title,
            salesPerson: val?.task?.assignedTo?.username,
            status: val.status,
            percentage: val.workCompleted + "%",
            hours: parseInt(val.hoursWorked) + " Hours",
            remainingTime: val?.remainingTime,
            createdAt: val.createdAt ? val.createdAt.slice(0, 10) : '',
        })),
      };

    //Fetching Task List
    const fetchAllTaskList = () => {
      setIsLoading(true);
        request(BASEURL, getTaskList, {
          userId: UserId
        })
          .then((res) => {
            setTaskProgressData(res.allProgressUpdates?.data || []);
          })
          .catch((err) => {
            console.error("Failed to fetch task progress data", err);
            setTaskProgressData([]);
          })
          .finally(() => {
            setIsLoading(false);
          })
    };
      
    const onTaskStatusClick = (e) => {
        if(e?.id){
            navigate(`/taskstatusmonitoring/add-Task-Status-Monitoring?${e?.id}`);
        }
    }

    const handleAddTaskStatus = () => {
        navigate("/taskstatusmonitoring/add-Task-Status-Monitoring");
      };

    const onCheck=(list)=>
    {
      console.log("id-c",list)
    }

    const onDeleteALL=()=>
      {
        console.log("id-DELE")
      }

    const onDelete=(id)=>
        {
          console.log("id-d",id)
        }
  return (
    <DashboardLayout
    tableData={globalSearchData} 
    setTableData={setGlobalSearchData}
    >
      <TableComponent
      tableLoading={isLoading ? true : false }
      rowsData={taskStatusListTable.rows}
      columns={taskStatusListTable.columns}
      styles={{ paper: { padding: '16px' } }}
      head="Task Progress List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onTaskStatusClick}
      onDelete={onDelete}
      onView={onTaskStatusClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleAddTaskStatus()}
      />
        {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Task Progress List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddTaskStatus()}
              >
                Add Task Progress
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
        rows={taskStatusListTable.rows}
        columns={taskStatusListTable.columns}
        isSelectable={false}
        onRowClick={onTaskStatusClick}
        loading={pageState.loading}
        localeText={{
          noRowsLabel: (
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={1}
            >
              <MaterialTypography
                variant="body2"
                fontWeight="medium"
                color="text"
              >
                No Task List found
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                You have not yet added any Task Progress details. Click on the
                "Add Task Progress" button to start adding Task Progress
                details.
              </MaterialTypography>
            </Stack>
          ),
        }}
        />
        </Card> */}
    </DashboardLayout>
  )
}

export default TaskStatusMonitoringList